export default __webpack_public_path__ + "static/media/1.db87916e.jpg";